import { useCallback, useRef } from 'react';

const LONG_PRESS_DURATION = 500;

type MobileLongClickProps = {
  onSelect: () => void;
};

const useMobileLongClick = ({ onSelect }: MobileLongClickProps) => {
  const timeoutRef = useRef(null);

  const handleTouchStart = useCallback(() => {
    timeoutRef.current = setTimeout(() => onSelect?.(), LONG_PRESS_DURATION);
  }, [onSelect]);

  const handleTouchEnd = useCallback(
    () => clearTimeout(timeoutRef?.current),
    [],
  );

  return {
    handleTouchEnd,
    handleTouchStart,
  };
};

export default useMobileLongClick;
